export enum SIDEBAR {
  /** 資源頁側欄：最新消息列表（非獨立路由） */
  latestNews = '最新消息',
  ebook = '電子書',
  tiku = '題庫光碟',
  supplementMaster = '教學大補帖',
  supplementMasterDisk = '教學大補帖光碟',
  materialLibrary = '備課素材庫',
  allResources = '補充資源全收錄',
  supplement = '備課資源',
  supplementData = '備課資料',
  schedule = '授課教案',
  test = '卷類資源',
  resourceEFile = '教材電子檔',
  resourcePdf = '教材PDF',
  resourceWord = '教材WORD',
  resource = '教材資源',
  ppt = '教學PPT',
  resourceImage = '教材圖檔',
  planAndSchedule = '課程計畫與教案',
  plan = '課程計畫',
  integratedInquiry = '統整性探究課',
  flexibleCourse = '彈性課程資源',
  media = '多媒體',
  videoResource = '影音資源',
  courseAudio = '課習音檔',
  worksheet = '數位教學學習單',
  elective = '多元選修',
  examPreparation = '升學-大考',
  examPreparationInfo = '升學-大考資訊',
  journalSection = '期刊專區',
  journal = '期刊',
  bilingualResource = '雙語教材資源',
  internet = '網路資源',
}

export enum INTERNETTAB {
  official = 'official',
  activityPlatform = 'activityPlatform',
  app = 'app',
  media = 'media',
  tool = 'tool',
  ebook = 'ebook',
  flash = 'flash',
  tiku = 'tiku',
}

export enum INTERNET_FILTER_TAB {
  official = '南一官方網站',
  activityPlatform = '線上互動平台',
  app = 'APP資源',
  media = '影音資源',
  tool = '小工具',
}

export enum EDomain {
  ONECLASS = 'oneclass.com.tw',
  BOX3 = 'nani.com.tw',
}

export enum adminTab {
  school = '學校-教學資源',
  cramSchools = '補教-教學資源',
  InternetResource = '學校-網路資源',
  record = '歷程紀錄',
}

export enum SELECT_ACTION {
  ALL,
  DELETE,
  RESET,
  ADD,
  EDIT,
}

export enum sortOrder {
  ASC,
  DESC,
}

export enum keyCookie {
  ONECLASS_CLIENT = 'nani_oneclass_login_token',
  REMEMBERED_USERNAME = 'nani_oneclass_username',
  ONEPASS_HOST_ID = 'onePass_hostId',
  ONEPASS_MOE_WEB = 'onePass_moe_web',
}

export enum UpdateStatus {
  /**
   * @description 已下載並為最新版
   */
  latest,
  /**
   * @description 已下載並為舊版
   */
  old,
  /**
   * @description 沒下載
   */
  unknown,
}

export enum SelectType {
  addAll,
  clearAll,
  add,
  clear,
}

export enum OverallFileStatus {
  finish,
  progressing,
  paused,
  non,
}

export enum FileCollection {
  onebook = '108課綱電子書',
  flash = 'Flash電子書',
  tiku = '題庫',
  resource = '我的資源',
}

export enum Authority {
  ADMIN = 'admin',
  EDITOR = 'editor',
  TEACHER = 'teacher',
  CLIENT = 'client', // 學生和家長
}

export enum SearchCategory {
  CRAM_SCHOOL = '補教',
  SCHOOL = '學校',
  INTERSECTION = '學校補教共同',
  PUBLIC = '公開',
}

export enum UpdateElectronStatus {
  error = 'error',
  checking = 'checking',
  updateAvailable = 'updateAvailable',
  downloading = 'downloading',
  downloadCompleted = 'downloadCompleted',
  updateNotAvailable = 'updateNotAvailable',
  updated = 'updated',
}
